import styled from 'styled-components';
import { LabelRegularM } from '../../styles/globals';
import { ITheme, IThemeProvider } from '../../styles/theme';

interface StyledInputProps {
  theme: ITheme;
  error?: boolean;
}

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const InputLabel = styled(LabelRegularM)`
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[100]};
      margin-left: ${theme.layout.spacing.nano};
  `}
`;

export const StyledInput = styled.input`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  width: 320px;
  outline: none;
  border-radius: 8px;
  ${({ theme, error }: StyledInputProps) => `
      height: 48px;
      background: ${theme.colors.neutral.primary[0]};
      border: ${
  error
    ? `2px solid ${theme.colors.support.orange[100]}`
    : `1px solid ${theme.colors.neutral.primary[10]}`
};
      padding: 14px 12px;
      ::placeholder,
      ::-webkit-input-placeholder {
        color: ${theme.colors.neutral.primary[40]};
      }
  `}
`;

export const ErrorIconCont = styled.div`
  position: absolute;
  top: 28px;
  right: 14px;
  svg {
    width: 20px;
    height: 20px;
  }
`;
